import React, { useContext, useEffect, useState } from 'react';
import Header from '../components/Header';
import UserAccessNav from '../components/UserAccessNav';
import PaginationControls from '../components/PaginationControls';
import AccessEventsTable from '../components/AccessEventsTable';
import { UserContext } from '../App';
import { listUserAccess, PagedResponse, UserAccessEvent } from '../util/userAccessApi';

const PAGE_SIZE = 25;

function UserAccessEvents() {
  const userCtx = useContext(UserContext);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<PagedResponse<UserAccessEvent> | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!userCtx.user) {
      return;
    }

    setLoading(true);
    setError(null);

    listUserAccess(page, PAGE_SIZE)
      .then((response) => setData(response))
      .catch((e: Error) => {
        console.error('Failed to load access events!', e);
        setError(e.message || 'Nepodarilo sa načítať prístupy.');
      })
      .finally(() => setLoading(false));
  }, [page, userCtx.user]);

  return (
    <div className="flex flex-col min-h-0 h-full">
      <Header />
      <UserAccessNav />

      <div className="flex-1 overflow-auto p-6">
        <h1 className="text-2xl font-bold">Prístupy používateľov</h1>

        {!userCtx.user && <div className="mt-4">Neprihlásený!</div>}
        {userCtx.user && loading && <div className="mt-4">Načítavam...</div>}
        {userCtx.user && error && <div className="mt-4 text-red-600">{error}</div>}
        {userCtx.user && data && !loading && !error && (
          <>
            <div className="mt-4">
              Celkom záznamov: <strong>{data.totalItems}</strong>
            </div>
            <AccessEventsTable events={data.items} emptyMessage="Zatiaľ nie sú žiadne prístupy." />
            <PaginationControls page={data.page} totalPages={data.totalPages} onChange={setPage} />
          </>
        )}
      </div>
    </div>
  );
}

export default UserAccessEvents;
